import request from '@/utils/request'
import router from '../../router'
import { downloadBlob } from '../../utils/helpers'
import uuid from 'uniq-id'

export default {
    getArticles: async({ commit, dispatch }, params) => {
        await request({
            method: 'get',
            url: 'client-news',
            responseType: params.excel ? 'blob' : 'json',
            params: {
                ...params
            }
        }).then(res => {
            if (res.data && res.data.items) {
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total
                })

                commit('SET_ARTICLES', res.data.items)
            } else if (res.data && params.excel) {
                downloadBlob(res.data, `Report_${uuid()}.xlsx`)
            }
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response.message
            }, { root: true })
        }).finally(() => {
            commit('SET_LOAD', false)
        })
    },
    dropArticle: async({ commit, dispatch }, id) => {
        return request({
            method: 'delete',
            url: `/client-news/${id}`
        }).then(() => {
            dispatch('addMessage', {
                type: 'success',
                message: 'deletedArticle'
            }, { root: true })
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response.message
            }, { root: true })
        })
    },
    getArticleById: async({ commit, dispatch }, id) => {
        return request({
            method: 'get',
            url: `/client-news/${id}`
        }).then(res => {
            if (res.data) {
                return res.data
            }
        }).catch(error => {
            if (error.response && error.response.data.code === 404) {
                router.push('/add-client-article'); return
            }
            dispatch('addMessage', {
                type: 'error',
                message: error.response.message
            }, { root: true })
        })
    },

    updateArticle: async({ commit, dispatch }, payload) => {
        const data = {
            status: payload.dto.status,
            header: payload.dto.header,
            text: payload.dto.text
        }

        return await request({
            method: 'put',
            url: `/client-news/${payload.id}`,
            data
        }).then(res => {
            if (res.data) {
                dispatch('addMessage', {
                    type: 'success',
                    message: 'savedArticle',
                    locale: true
                }, { root: true })
            }
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response.data.message
            }, { root: true })
        })
    }
}
